import React, { Component } from "react";

class Intro extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const className = `column is-4-fullhd is-4-widescreen is-6-desktop is-6-tablet floating-info ${this.props.animation}`;
    return (
      <div className="container">
        <div className="columns">
          <div className={className}>
            <h1 className="title has-text-light">„СЛС Имоти” АДСИЦ</h1>
            <p>
              акционерно дружество със специална инвестиционна цел за секюритизация на недвижими
              имоти
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/presentational/Intro/index.js